import React from 'react';
import { Pane, Text, TextInput } from '@leverege/ui-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Detail(props) {
  const {
    id,
    label,
    value,
    hint,
    onChange,
    error
  } = props;
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:colSpaceBetween",
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "bodySmallBold",
      children: label
    }), /*#__PURE__*/_jsx(TextInput, {
      eventData: id,
      onChange: onChange,
      value: value,
      hint: hint
    }), /*#__PURE__*/_jsx(Text, {
      variant: "inputCaptionSmallError",
      children: error
    })]
  });
}